import { useQuery } from "react-query";

import { fetchFleetOperators } from "./fleetOperators";
import { notification } from "antd";

export const useFleetOperators = () => {
  const { data, isLoading } = useQuery(["fleetOperators"], () => fetchFleetOperators(), {
    onError: (error) => {
      notification.error({
        message: "Error retrieving fleet operators",
        description: `${error}`,
      });
    },
  });

  return { data, isLoading };
};
